<template>
  <div class="separator-vertical">{{text}}<slot></slot></div>
</template>
<script>
export default {
  name: 'SeparatorVertical',
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
.separator-vertical{
  padding-left: 10px;
  font-size:16px;
  font-family:SFProDisplay-Medium;
  font-weight:500;
  position: relative;
  margin-bottom: 12px;
  &:before{
    content: ' ';
    position: absolute;
    display: inline-block;
    left: 0;
    width: 2px;
    height: 12px;
    top: 50%;
    margin-top: -6px;
    background-color: $primary;
  }
}
</style>
